module.exports = __webpack_public_path__ + "img/3.47e6bcfe.png";